import React,{useState,useEffect,useContext} from 'react'
import {Container} from 'react-bootstrap'
import LoadingFailed from '../../components/LoadingFailed/index.js'
import Loading from '../../components/Loading/index.js'
import EmptyList from '../../components/EmptyList/index.js'
import { useParams } from 'react-router';
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import AuthContext from '../../context/AuthContext.js'
import PrefixContext from '../../context/PrefixContext.js'
import Template1 from '../../resumes/t1/index.js'
import Template2 from '../../resumes/t2/index.js'

function Resume() {

    const { id } = useParams();
    const [resumedata, setresumedata] = useState()
    const [loading, setloading] = useState('LOADING');
    const AuthContextData = useContext(AuthContext);
    const PrefixContextData = useContext(PrefixContext);

    const getResumeData = async () => {
        let token = localStorage.getItem('auth-token');
        axios.defaults.headers.common['Authorization'] = token;
        axios.get(PrefixContextData.prefixUrl+'data/resume/'+id)
            .then(response => {
                if(response.status === 200){
                    setloading('LOADED');
                    setresumedata(response.data);
                }
                else{
                    setloading('FAILED');
                    console.log('Resume Data Loading Failed')
                }
            })
            .catch(error => {
                if(error.response!==undefined){
                    if(error.response.status === 401){
                        AuthContextData.logout()
                    }
                }
                setloading('FAILED');
                console.log('Resume Data Loading Failed')
            });
    }

    useEffect(() => {
        getResumeData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])


    return (
        <>
        <section className="page-heading-margin bg-secondary">
            <Container>
                {loading === 'LOADING' && <Loading type="withImage" />}
                {loading === 'FAILED' && <LoadingFailed type="withImage" />}
                {
                    (loading === 'LOADED' &&  (resumedata !== undefined && Array.isArray(resumedata) && resumedata.length === 0)) && 
                    <EmptyList type="withImage" label="No Such Resume Found."/>
                }
                {
                    (loading === 'LOADED' &&  (resumedata !== undefined && Array.isArray(resumedata) && resumedata.length !== 0)) &&
                    <>
                        {
                            resumedata.map((el)=>{
                                if(el.template_id !== undefined && el.template_id.identity !== undefined)
                                {
                                    if(el.template_id.identity === "TemplateOne"){
                                        return <Template1 key={uuidv4()} {...el}/>
                                    }
                                    else if(el.template_id.identity === "TemplateTwo"){
                                        return <Template2 key={uuidv4()} {...el}/>
                                    }
                                    else{
                                        return null;
                                    }
                                }
                                else{
                                    return null;
                                }
                            })
                        }
                    </>
                }
            </Container>
        </section>
        </>
    )
}

export default Resume
